import { Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import { FlatInputStyleTitle, MultiplePaintingTitle, PleaseComments, RomanNumberTitle } from "../../../../../constants";
import { FlatInputStyleSubTitle, MultiplePaintingFlatData, RomanFlatInputData } from "../../../../../data/formsAndTable/forms/FormControls";
import CommonSelectDropdown from "../../common/CommonSelectDropdown";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const FlatInputStyle = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FlatInputStyleTitle} span={FlatInputStyleSubTitle} />
        <Form className="theme-form dark-inputs">
          <CardBody>
            <Row>
              <CommonSelectDropdown title={RomanNumberTitle} inputClass="btn-square" options={RomanFlatInputData} />
            </Row>
            <Row>
              <CommonSelectDropdown title={MultiplePaintingTitle} options={MultiplePaintingFlatData} inputClass="btn-square custom-scrollbar" multiple={true} optionClass="rounded-0" />
            </Row>
            <Row>
              <Col>
                <div>
                  <Label>{PleaseComments}</Label>
                  <Input type="textarea" className="btn-square" rows="3"></Input>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Form>
      </Card>
    </Col>
  );
};
export default FlatInputStyle;
